import React from 'react';
import { PolIcon } from "components/PolIcon/policon";

import "./NotifyMe.scss";
import ReactTooltip from "react-tooltip";
import useNotifyMe from "v4/components/utils/NotifyMe/hooks/useNotifyMe";
import { usePolTranslation } from "v4/hooks/usePolTranslation";

export default function NotifyMe({tipPlacement = "top"}) {
    const {t} = usePolTranslation();
    const { state, onClick } = useNotifyMe();

    return (
        <div className={`notify-me ${state.className}`}>
            <button
                className="notify-me__content"
                data-for="notify-me-tooltip"
                data-tip={t(state.tip)}
                onClick={onClick}
            >
                <PolIcon icon={state.icon} className="notify-me__icon"/>
            </button>
            <ReactTooltip key={state.tip}
                          id="notify-me-tooltip"
                          place={tipPlacement}
                          effect="solid"
                          className="notify-me__tooltip"
            />
        </div>
    )
}
